// /corpora/:corpusId/merges — Pass 2 merge review (PRD 00 §Pass 2 trigger).

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { MergeQueuePage } from "../review/corpus/MergeQueuePage";

export const corpusMergesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/corpora/$corpusId/merges",
  component: MergeQueueRoute,
});

function MergeQueueRoute() {
  const { corpusId } = corpusMergesRoute.useParams();
  return <MergeQueuePage corpusId={corpusId} />;
}
